export default __webpack_public_path__ + "static/media/7Klein.6f5881d4.jpg";